// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__nuWly","fullScreen":"Loader_fullScreen__bRSKr","spin":"Loader_spin__0Ioql","text":"Loader_text__06W9W"};